import * as React from 'react';
import { observer } from 'mobx-react';
import { PageEnterMobileNumberViewModel } from './page-enter-mobile-number-view-model';
import { WebGivingUserAction } from '../../webgiving-user-actions';
import { SubmitButton } from '../../components/submit-button/submit-button';
import { MobilePhoneControl } from '../../components/mobile-phone-control/mobile-phone-control';
import { FormControl } from '../../components/form-control/form-control';
import { Form } from '../../primitives/form';
import { ErrorMessage } from '../../components/error-message/error-message';
import { Link, InfoLink } from '../../primitives/link/link';
import { FadeTransition } from '../../components/fade-transition';
import { PanelContentTransition } from '../../components/panel-content-transition';
import { getPageClasses} from '../helpers/get-page-classes';
import { PanelHeading } from '../../components/panel-heading';
import { ModalType } from '../../modals/modal-type';
import { injectWebGivingProps, InjectableWebGivingProps, raiseAction } from '../../utils/injectable-props';
import { PanelFooter } from '../../components/panel-footer';
import { Text } from '../../components/text';

import * as style from './page-enter-mobile-number.less';
import { pageFooter } from '../../main/webgiving-main.less';

export { PageEnterMobileNumberViewModel };

@injectWebGivingProps
@observer
export class PageEnterMobileNumber extends React.Component<{
	vm: PageEnterMobileNumberViewModel,
	transitionState: string,
} & InjectableWebGivingProps> {
	panelBodyNode: HTMLDivElement;

	render() {
		const { vm, transitionState } = this.props;
		const {
			error,
			mobileNumber,
			mobileCountry,
			isLoading,
			pageShouldBeVisible,
			isBlocked,
		} = vm;
		const elementsShouldEnter = transitionState === 'entered';

		return (
			<div className={getPageClasses(pageShouldBeVisible, isLoading)} data-pp-at-target={pageShouldBeVisible ? `Enter Mobile Number page` : null}>
				<Form onSubmit={this.handleSubmit}>
					<PanelHeading vm={vm}>
						<FadeTransition in={elementsShouldEnter}>
							<div>
								<h1 className="panel-title"><Text>VERIFY YOUR MOBILE NUMBER</Text></h1>
								<p className="panel-subtitle"><Text>{NewFeatures.WebGiving_FastMode ? `Enter your number so we can sign you in.` : `Enter your number so we can send you a security code.`}</Text></p>
								<InfoLink acceptanceTestTargetId="How does mobile sign in work" onClick={this.showMobileSigninInfo} branded={false}>
								<Text>How does mobile sign in work?</Text>
								</InfoLink>
							</div>
						</FadeTransition>
					</PanelHeading>
					<div className="panel-body panel-body-form" ref={this.savePanelBodyNode}>
						<PanelContentTransition in={elementsShouldEnter} setContentHeight={this.setContentHeight} className="panel-body-content">
							<div>
								<ErrorMessage error={error} />
								<div className="row">
									<div className={`col-sm-8 col-centered ${style.mobileNumberField}`}>
										<FormControl label="Mobile number" validationError={mobileNumber.validationError}>
											<MobilePhoneControl
												numberField={mobileNumber}
												countryField={mobileCountry}
												acceptanceTestTargetId="Mobile number"
												focusOnMount={true}
												aria-required={true}
											/>
										</FormControl>
										<div className={style.needHelp}><Link acceptanceTestTargetId="Need help" onClick={this.showHelp} branded={false}><Text>Need help?</Text></Link></div>
									</div>
								</div>
							</div>
						</PanelContentTransition>
					</div>
					<PanelFooter className={pageFooter}>
						<SubmitButton acceptanceTestTargetId="Send code" isLoading={isLoading} isBlocked={isBlocked}><Text>{NewFeatures.WebGiving_FastMode ? 'Next' : 'Send code'}</Text></SubmitButton>
					</PanelFooter>
				</Form>
			</div>
		);
	}

	setContentHeight = (offsetHeight: number) => {
		if (this.panelBodyNode) {
			this.panelBodyNode.style.minHeight = `${offsetHeight}px`;
		}
	}

	private savePanelBodyNode = (panelBodyNode: HTMLDivElement) => this.panelBodyNode = panelBodyNode;

	private showHelp = () => {
		raiseAction(new WebGivingUserAction.OpenModalDialog(ModalType.NeedHelp), this.props);
	}

	private showMobileSigninInfo = () => {
		raiseAction(new WebGivingUserAction.OpenModalDialog(ModalType.MobileSignInInfo), this.props);
	}


	private handleSubmit = () => {
		raiseAction(new WebGivingUserAction.SubmitCurrentPage(), this.props);
	}
}

